import { render, staticRenderFns } from "./clientes-resume.vue?vue&type=template&id=5babf756&scoped=true&lang=pug&"
import script from "./clientes-resume.vue?vue&type=script&lang=ts&"
export * from "./clientes-resume.vue?vue&type=script&lang=ts&"
import style0 from "./clientes-resume.vue?vue&type=style&index=0&id=5babf756&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5babf756",
  null
  
)

export default component.exports